import { useTranslation } from '@hooks/useTranslation';
import React, { FC } from 'react';
import s from './toysSummary.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { Divider } from '@components/UIKit/Divider/Divider';
import { PriceInCurrency } from '@components/Pages/CartPage/Summary/ToysSummary/PriceInCurrency';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
interface Props {
  buySelectedHandler: () => void;
  rubyToysCount: number;
  goldToysCount: number;
}
export const ToysSummary: FC<Props> = ({
  buySelectedHandler,
  goldToysCount,
  rubyToysCount
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    data: profile
  } = useProfile();
  if (!profile) return null;
  return <div className={s.summary} data-sentry-component="ToysSummary" data-sentry-source-file="ToysSummary.tsx">
            <div className={s.summary__main}>
                <div className={s.summary__title}>
                    {tr({
          id: 'cart.page.to.buy'
        })}
                </div>
                <div className={s.summary__currencies}>
                    {!!rubyToysCount && <PriceInCurrency amount={rubyToysCount} currency={'RUBY'} text={'cart.page.price.in.rubies'} />}
                    {!!goldToysCount && <PriceInCurrency amount={goldToysCount} currency={'GOLD'} text={'cart.page.price.in.gold'} />}
                </div>
                <Divider data-sentry-element="Divider" data-sentry-source-file="ToysSummary.tsx" />
            </div>
            <Button id='toy_summary_buy_button' size={'large'} color={'Black'} onClick={buySelectedHandler} data-sentry-element="Button" data-sentry-source-file="ToysSummary.tsx">
                {tr({
        id: 'btn.buy'
      })}
            </Button>
        </div>;
};